export const shouldDisplayMainPadding = (should: string): boolean => {
	if (should === "false") {
		return false;
	} else {
		return true;
	}
};
